import { ColorDynamic } from "../theme/Color.js";
export function overrideSvgIcon(theme) {
  var sm = theme.breakpoints.up('sm');
  theme.overrides.MuiSvgIcon = {
    root: {
      display: 'inherit',
      fontSize: 'var(--mui-svg-icon-size, 32px)',
      [sm]: {
        fontSize: 'var(--mui-svg-icon-size, 24px)'
      }
    },
    fontSizeSmall: {
      fontSize: 'var(--mui-svg-icon-size, 24px)',
      [sm]: {
        fontSize: 'var(--mui-svg-icon-size, 16px)'
      }
    },
    fontSizeLarge: {
      fontSize: 'var(--mui-svg-icon-size, 32px)'
    },
    colorAction: {
      color: ColorDynamic.Dark100
    },
    colorPrimary: {
      color: ColorDynamic.Blue500
    }
  };
}